import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTick = createSVG({
    children: (jsx("path", { d: "M19.742 6.511q.258.234.258.61 0 .352-.258.585l-9.856 9.877a.62.62 0 0 1-.639.123.5.5 0 0 1-.182-.123l-4.807-4.805A.76.76 0 0 1 4 12.192q0-.374.258-.633a.88.88 0 0 1 .61-.234q.352 0 .61.234l3.586 3.586a.54.54 0 0 0 .398.164.62.62 0 0 0 .423-.164L18.52 6.51a.83.83 0 0 1 .61-.258q.352 0 .61.258" })),
});

export { IconTick };
